<app-top-navigation [hidden]="true"></app-top-navigation>
<!-- <head>
	<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
		integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
		crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>
<div class="basic-container" *ngIf="this.message.showLeftMenu=='Main'">
	<div *ngFor="let item of treeDataSource, let i = index;">
		<div *ngIf="item.children && item.children.length > 0"
			[ngClass]=" i == qmsservice.highlightBackground ? 'selected-menu' : ''">
			<div class="row" mat-button [matMenuTriggerFor]="menu.childMenu" (click)="secondLevel(item.name, i);">
				<div class="item-block">
					<div class="item-name-icon"><i [className]="
			    item.name=='My Tasks' ? 'fas fa-tasks' : 
				item.name=='Quality' ? 'fas fa-certificate' : 
				item.name=='Trainings' ? 'fas fa-chalkboard-teacher' : 
				item.name=='Dashboards' ? 'fas fa-chart-bar' :
				 item.name=='Documents' ? 'fas fa-folder-open' :
				  item.name=='Admin' ? 'fas fa-users-cog' : 
				  item.name=='Settings' ? 'fas fa-cog' : 
				  item.name=='Topics' ? 'fa-solid fa-file-lines' : 
				  item.name=='Releases' ? 'fa-solid fa-bars-staggered' : 
				  item.name =='Organization' ? 'fa-solid fa-building-o' :
				  item.name=='Home' ? 'fa-solid fa-house' : 
				  item.name=='Logs' ? 'fa fa-file-text' : '' " aria-hidden="true"></i></div>
					<div class="item-name">&nbsp;{{item.name}}</div>
				</div>
			</div>
			<app-menu-item #menu [items]="item.children"></app-menu-item>
		</div>
		<div *ngIf="!item.children || item.children.length === 0">
			<div class="row" mat-button class=" item-block" (click)="secondLevel(item.name, i)">
				<div>
					<div class="item-name-icon"><i [className]="item.name=='My Tasks' ? 'fas fa-tasks' : 
				item.name=='Quality' ? 'fas fa-certificate' : 
				item.name=='Trainings' ? 'fas fa-chalkboard-teacher' : 
				item.name=='Dashboards' ? 'fas fa-chart-bar' :
				 item.name=='Documents' ? 'fas fa-folder-open' :
				  item.name=='Admin' ? 'fas fa-users-cog' : 
				  item.name=='Settings' ? 'fas fa-cog' : 
				  item.name=='Topics' ? 'fa-solid fa-file-lines' : 
				  item.name=='Releases' ? 'fa-solid fa-bars-staggered' : 
				  item.name=='Logs' ? 'fa-solid fa-file-text' :   
				  item.name=='Home' ? 'fa-solid fa-house' : ''" aria-hidden="true"></i>
				 <div class="item-name">&nbsp;{{item.name}}</div>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="basic-container" *ngIf="this.message.showLeftMenu=='Activity'">
	<div *ngFor="let item of message.activityLeftmenuList">
		<div [hidden]="(message.showActionSection==false && item.name=='Actions') ||
		(message.showAddtionalDetailSection==false && item.name=='Additional Information') || (message.showEffectiveSection==false && item.name=='Effectiveness Check')
		||(message.showDocumentSection==false && item.name=='Documents') || (message.showReviewApproveSection==false && item.name=='Reviewers/Approvers')
		||(message.showExtensionSection==false && item.name=='Extensions') || (message.showNotificationSection==false && item.name=='Notifications/Reminders')
		|| (message.showDependancySection==false && item.name=='Dependency')">
			<div class="row" mat-button class="activity-item-block" (click)="ActivityPages(item.name)"
				[title]="item.name">
				<div>
					<div class="item-name-icon"><i [className]="
					item.name=='Change Request' ? 'fa-solid fa-file-pen' : 
					item.name=='Additional Information' ? 'far fa-info-circle' :
					item.name=='Documents' ? 'fa-regular fa-file' :
					item.name=='Reviewers/Approvers' ? 'fa-solid fa-file-circle-check' :
					item.name=='Notifications/Reminders' ? 'far fa-bell' :
					item.name=='Effectiveness Check' ? 'far fa-check-square' :
					item.name=='Extensions' ? 'fa-regular fa-file-code' :
					item.name=='Actions' ? 'fa-solid fa-file-invoice' :
					item.name=='Dependency' ? 'fa-solid fa-layer-group' : 'fas fa-chart-bar'" aria-hidden="true"></i></div>
				</div>
			</div>
		</div>
	</div>
</div> -->

<!-- 
<mat-tree [dataSource]="dataSource"
		[treeControl]="treeControl">
	<mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
		
		<button mat-icon-button disabled></button>
		<span (click)="treenavigation(node)">	
        {{node.name}}
    </span>
	</mat-tree-node>
	
	<mat-tree-node
		*matTreeNodeDef="let node;when: hasChild"
		matTreeNodePadding>
		<button  mat-icon-button matTreeNodeToggle
			[attr.aria-label]=
			"'Toggle ' + node.name">
			<mat-icon class="mat-icon-rtl-mirror">
			
                {{treeControl.isExpanded(node) ?
					'expand_more' : 'chevron_right'}}
			</mat-icon>
		</button>
			{{node.name}}
	</mat-tree-node>
</mat-tree> -->

<head>
	<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
		integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
		crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>
<div class="basic-container" *ngIf="this.message.showLeftMenu == 'Main'">
	<div class="one_qms_logo_block">
		<img *ngIf="oneQmsOrgImagesDetails.oneQmsImageFileName" class="org-image" alt="logo" [attr.width]="65"
			[attr.height]="20"
			[src]="'../../assets/img/' + (oneQmsOrgImagesDetails.oneQmsImageFileName === 'oneqmslogo.png' ? 'oneqmslogo_1.png' : 'eqmslogo_1.png')">
	</div>
	<div *ngFor="let item of treeDataSource; let i = index">
		<!-- Handle branch node buttons here -->
		<div *ngIf="item.children && item.children.length > 0"
			[ngClass]="i == qmsservice.highlightBackground ? 'selected-menu' : ''">
			<div class="row left_menu" mat-button [matMenuTriggerFor]="menu?.childMenu"
				(click)="secondLevel(item.name, i)">
				<div class="item-block">
					<div class="item-name-icon">
						<!-- <img
				*ngIf="item.name === 'Home'"
				src="../../assets/img/home.svg"
				alt="Home"
				width="20"
				height="20"
			  /> -->

						<svg *ngIf="item.name === 'Home'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
							viewBox="0 0 20 20" fill="none">
							<path
								d="M7.33333 18V11.9136C7.33333 11.3534 7.8109 10.8992 8.4 10.8992H11.6C12.1891 10.8992 12.6667 11.3534 12.6667 11.9136V18M9.38184 2.18771L2.44851 6.87647C2.16713 7.06676 2 7.3748 2 7.70316V16.4784C2 17.3188 2.71634 18 3.6 18H16.4C17.2837 18 18 17.3188 18 16.4784V7.70316C18 7.3748 17.8329 7.06676 17.5515 6.87647L10.6182 2.18771C10.2481 1.93743 9.75193 1.93743 9.38184 2.18771Z"
								[ngStyle]="{stroke: i == qmsservice.highlightBackground ? '#005C8A' : '#FFFFFF'}"
								stroke="white" stroke-width="2" stroke-linecap="round" />
						</svg>

						<!-- <img
				*ngIf="item.name === 'My Tasks'"
				src="../../assets/img/my_tasks.svg"
				alt="My Tasks"
				width="20"
				height="20"
			  /> -->

						<svg *ngIf="item.name === 'My Tasks'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
							viewBox="0 0 20 20" fill="none">
							<path
								d="M7.26667 5H18M7.26667 10.4H18M7.26667 15.8H18M3 5V5.01067M3 10.4V10.4107M3 15.8V15.8107"
								[ngStyle]="{stroke: i == qmsservice.highlightBackground ? '#005C8A' : '#FFFFFF'}"
								stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
						<!-- <img
				*ngIf="item.name === 'Quality'"
				src="../../assets/img/quality_menu.svg"
				alt="Quality"
				width="20"
				height="20"
			  /> -->
						<svg *ngIf="item.name === 'Quality'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
							viewBox="0 0 20 20" fill="none">
							<path
								d="M2.50018 10H4.16685V17.5H2.50018V10ZM15.8335 6.66667H17.5002V17.5H15.8335V6.66667ZM9.16685 1.66667H10.8335V17.5H9.16685V1.66667Z"
								[ngStyle]="{fill: i == qmsservice.highlightBackground ? '#005C8A' : '#FFFFFF'}" />
						</svg>

						<!-- <img
				*ngIf="item.name === 'Trainings'"
				src="../../assets/img/training.svg"
				alt="Trainings"
				width="20"
				height="20"
			  /> -->
						<svg *ngIf="item.name === 'Business Process'" width="24" height="25" viewBox="0 0 24 25"
							fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M11.5 16.747L10.6009 17.1847C10.7651 17.522 11.1042 17.739 11.4792 17.7468C11.8542 17.7546 12.202 17.5519 12.3801 17.2218L11.5 16.747ZM8.69913 8.7093C8.45739 8.21273 7.85887 8.00616 7.3623 8.24791C6.86574 8.48966 6.65917 9.08818 6.90091 9.58474L8.69913 8.7093ZM16.4801 9.62181C16.7423 9.13575 16.5609 8.52914 16.0748 8.26692C15.5887 8.0047 14.9821 8.18616 14.7199 8.67223L16.4801 9.62181ZM7.40002 8.54702C7.40002 9.09931 7.84774 9.54702 8.40002 9.54702C8.95231 9.54702 9.40002 9.09931 9.40002 8.54702H7.40002ZM14 8.54702C14 9.09931 14.4477 9.54702 15 9.54702C15.5523 9.54702 16 9.09931 16 8.54702H14ZM12.3991 16.3093L8.69913 8.7093L6.90091 9.58474L10.6009 17.1847L12.3991 16.3093ZM12.3801 17.2218L16.4801 9.62181L14.7199 8.67223L10.6199 16.2722L12.3801 17.2218ZM9.40002 8.54702V6.14702H7.40002V8.54702H9.40002ZM9.60002 5.94702H13.8V3.94702H9.60002V5.94702ZM14 6.14702V8.54702H16V6.14702H14ZM13.8 5.94702C13.9105 5.94702 14 6.03657 14 6.14702H16C16 4.93199 15.015 3.94702 13.8 3.94702V5.94702ZM9.40002 6.14702C9.40002 6.03656 9.48957 5.94702 9.60002 5.94702V3.94702C8.385 3.94702 7.40002 4.93199 7.40002 6.14702H9.40002ZM4.80002 9.54702H19.2V7.54702H4.80002V9.54702ZM20.6 10.947V18.147H22.6V10.947H20.6ZM19.2 19.547H4.80002V21.547H19.2V19.547ZM3.40002 18.147V10.947H1.40002V18.147H3.40002ZM4.80002 19.547C4.02683 19.547 3.40002 18.9202 3.40002 18.147H1.40002C1.40002 20.0248 2.92226 21.547 4.80002 21.547V19.547ZM20.6 18.147C20.6 18.9202 19.9732 19.547 19.2 19.547V21.547C21.0778 21.547 22.6 20.0248 22.6 18.147H20.6ZM19.2 9.54702C19.9732 9.54702 20.6 10.1738 20.6 10.947H22.6C22.6 9.06925 21.0778 7.54702 19.2 7.54702V9.54702ZM4.80002 7.54702C2.92226 7.54702 1.40002 9.06925 1.40002 10.947H3.40002C3.40002 10.1738 4.02683 9.54702 4.80002 9.54702V7.54702Z"
								[ngStyle]="{fill: i == qmsservice.highlightBackground ? '#005C8A' : '#FFFFFF'}"
								stroke="white" stroke-width="0" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
						<svg *ngIf="item.name === 'Trainings'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
							viewBox="0 0 20 20" fill="none">
							<path
								d="M2 18L2.00034 14.9997C2.00052 13.3429 3.34361 12 5.00034 12H10.5M14 12.6429L16 10.5M16 10.5L18 12.6429M16 10.5V16M14.5 2C15.7135 2.68023 16.5 3.77073 16.5 5C16.5 6.22927 15.7135 7.31977 14.5 8M12 5C12 6.65685 10.6569 8 9 8C7.34314 8 6 6.65685 6 5C6 3.34315 7.34314 2 9 2C10.6569 2 12 3.34315 12 5Z"
								[ngStyle]="{stroke: i == qmsservice.highlightBackground ? '#005C8A' : '#FFFFFF'}"
								stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
						<svg *ngIf="item.name === 'Logs'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
							viewBox="0 0 24 25" fill="none">
							<path
								d="M7.20002 12.1471L10.2 15.1471L7.20002 18.1471M3.00002 8.54709H21M4.80002 22.3471C3.47454 22.3471 2.40002 21.2726 2.40002 19.9471V5.54709C2.40002 4.22161 3.47454 3.14709 4.80002 3.14709H19.2C20.5255 3.14709 21.6 4.22161 21.6 5.54709V19.9471C21.6 21.2726 20.5255 22.3471 19.2 22.3471H4.80002Z"
								[ngStyle]="{stroke: i == qmsservice.highlightBackground ? '#005C8A' : '#FFFFFF'}"
								stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
						<svg *ngIf="item.name === 'Organization'" xmlns="http://www.w3.org/2000/svg" width="24"
							height="25" viewBox="0 0 24 25" fill="none">
							<path
								d="M4.00002 15.7471V13.0784M9.33336 15.7471V13.0784M14.6667 15.7471V13.0784M20 15.7471V13.0784M2.40002 19.1471H21.6V22.3471H2.40002V19.1471ZM2.40002 9.54709V7.41376L11.6055 3.14709L21.6 7.41376V9.54709H2.40002Z"
								stroke="#005C8A"
								[ngStyle]="{stroke: i == qmsservice.highlightBackground ? '#005C8A' : '#FFFFFF'}"
								stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>

						<!-- <img
				*ngIf="item.name === 'Documents'"
				src="../../assets/img/documents.svg"
				alt="Documents"
				width="20"
				height="20"
			  /> -->

						<svg *ngIf="item.name === 'Documents'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
							viewBox="0 0 20 20" fill="none">
							<path
								d="M2.00086 7.0139L2.00078 14.6175C2.00077 15.7221 2.8962 16.6175 4.00078 16.6175L15.9997 16.6175C17.1043 16.6176 17.9997 15.7222 17.9997 14.6176L18 6.84372C18 6.29142 17.5523 5.84369 17 5.84369H10.0697L7.76555 3.38232H3.00038C2.44794 3.38232 2.00017 3.82964 2.00034 4.38207C2.00058 5.16753 2.00086 6.2523 2.00086 7.0139Z"
								[ngStyle]="{stroke: i == qmsservice.highlightBackground ? '#005C8A' : '#FFFFFF'}"
								stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>

						<!-- <img
				*ngIf="item.name === 'Dashboards'"
				src="../../assets/img/dashboard.svg"
				alt="Dashboards"
				width="20"
				height="20"
			  /> -->
						<svg *ngIf="item.name === 'Dashboard'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
							viewBox="0 0 20 20" fill="none">
							<path
								d="M16.2222 1.99998C17.2041 1.99998 18 2.78502 18 3.75341L18 6.74659C18 7.71498 17.2041 8.50001 16.2222 8.50001H13.5556C12.5737 8.50001 11.7778 7.71498 11.7778 6.74659L11.7778 3.75341C11.7778 2.78502 12.5737 1.99998 13.5556 1.99998L16.2222 1.99998Z"
								stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
							<path
								d="M3.77778 1.99998C2.79594 1.99998 2 2.78502 2 3.75341L2.00001 6.74659C2.00001 7.71498 2.79595 8.50001 3.77778 8.50001H6.44445C7.42629 8.50001 8.22223 7.71498 8.22223 6.74659L8.22222 3.75341C8.22222 2.78502 7.42628 1.99998 6.44444 1.99998L3.77778 1.99998Z"
								stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
							<path
								d="M16.2222 11.5C17.2041 11.5 18 12.285 18 13.2534V16.2466C18 17.215 17.2041 18 16.2222 18H13.5556C12.5737 18 11.7778 17.215 11.7778 16.2466L11.7778 13.2534C11.7778 12.285 12.5737 11.5 13.5556 11.5H16.2222Z"
								stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
							<path
								d="M3.77778 11.5C2.79594 11.5 2.00001 12.285 2.00001 13.2534L2.00001 16.2466C2.00001 17.215 2.79595 18 3.77779 18H6.44445C7.42629 18 8.22223 17.215 8.22223 16.2466L8.22223 13.2534C8.22223 12.285 7.42629 11.5 6.44445 11.5H3.77778Z"
								[ngStyle]="{stroke: i == qmsservice.highlightBackground ? '#005C8A' : '#FFFFFF'}"
								stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
						<!-- <img
				*ngIf="item.name === 'Admin'"
				src="../../assets/img/admin.svg"
				alt="Admin"
				width="20"
				height="20"
			  /> -->
						<svg *ngIf="item.name === 'Admin'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
							viewBox="0 0 20 20" fill="none">
							<path
								d="M10 14V16M7 17H13M4 14H16C17.1046 14 18 13.1046 18 12V5C18 3.89543 17.1046 3 16 3H4C2.89543 3 2 3.89543 2 5V12C2 13.1046 2.89543 14 4 14Z"
								[ngStyle]="{stroke: i == qmsservice.highlightBackground ? '#005C8A' : '#FFFFFF'}"
								stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
						<!-- <img
				*ngIf="item.name === 'Settings'"
				src="../../assets/img/setup.svg"
				alt="Settings"
				width="20"
				height="20"
			  /> -->
						<svg *ngIf="item.name === 'Settings'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
							viewBox="0 0 20 20" fill="none">
							<path
								d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z"
								[ngStyle]="{fill: i == qmsservice.highlightBackground ? '#005C8A' : '#FFFFFF'}" />
						</svg>


						<!-- <img
				*ngIf="item.name === 'Sign Out'"
				src="../../assets/img/sign_out.svg"
				alt="Sign Out"
				width="20"
				height="20"
			  /> -->
						<svg *ngIf="item.name === 'Logout'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
							viewBox="0 0 20 20" fill="none">
							<path
								d="M12.2059 6.5V4.75C12.2059 4.28587 12.02 3.84075 11.689 3.51256C11.3581 3.18437 10.9092 3 10.4412 3H4.26471C3.79668 3 3.34782 3.18437 3.01687 3.51256C2.68592 3.84075 2.5 4.28587 2.5 4.75V15.25C2.5 15.7141 2.68592 16.1592 3.01687 16.4874C3.34782 16.8156 3.79668 17 4.26471 17H10.4412C10.9092 17 11.3581 16.8156 11.689 16.4874C12.02 16.1592 12.2059 15.7141 12.2059 15.25V13.5M6.91176 10H17.5M17.5 10L14.8529 7.375M17.5 10L14.8529 12.625"
								stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>

						<!-- <i
				[className]="
				  item.name == 'My Tasks'
					? 'fas fa-tasks'
					: item.name == 'Quality'
					? 'fas fa-certificate'
					: item.name == 'Trainings'
					? 'fas fa-chalkboard-teacher'
					: item.name == 'Dashboards'
					? 'fas fa-chart-bar'
					: item.name == 'Documents'
					? 'fas fa-folder-open'
					: item.name == 'Admin'
					? 'fas fa-users-cog'
					: item.name == 'Settings'
					? 'fas fa-cog'
					: item.name == 'Topics'
					? 'fa-solid fa-file-lines'
					: item.name == 'Releases'
					? 'fa-solid fa-bars-staggered'
					: item.name == 'Organization'
					? 'fa-solid fa-building-o'
					: item.name == 'Home'
					? 'fa-solid fa-house'
					: ''
				"
				aria-hidden="true"
			  ></i> -->
					</div>
					<div [ngClass]="i == qmsservice.highlightBackground ? 'active_menu' : 'item-name'">&nbsp;{{
						item.name }}</div>
					<!-- <div *ngIf="showLeftMenu" class="pull-right item-name-icon"><i class="fa fa-caret-right"  aria-hidden="true"></i></div> -->
				</div>
			</div>
			<app-menu-item #menu [items]="item.children"></app-menu-item>
		</div>

		<!-- Leaf node buttons here -->
		<div *ngIf="!item.children || item.children.length === 0"
			[ngClass]="i == qmsservice.highlightBackground ? 'selected-menu' : ''">
			<div class="row left_menu" mat-button (click)="secondLevel(item.name, i)">
				<div class="item-block">
					<div class="item-name-icon">
						<!-- <img
				*ngIf="item.name === 'Home'"
				src="../../assets/img/home.svg"
				alt="Home"
				width="20"
				height="20"
			  /> -->
						<svg *ngIf="item.name === 'Home'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
							viewBox="0 0 20 20" fill="none">
							<path
								d="M7.33333 18V11.9136C7.33333 11.3534 7.8109 10.8992 8.4 10.8992H11.6C12.1891 10.8992 12.6667 11.3534 12.6667 11.9136V18M9.38184 2.18771L2.44851 6.87647C2.16713 7.06676 2 7.3748 2 7.70316V16.4784C2 17.3188 2.71634 18 3.6 18H16.4C17.2837 18 18 17.3188 18 16.4784V7.70316C18 7.3748 17.8329 7.06676 17.5515 6.87647L10.6182 2.18771C10.2481 1.93743 9.75193 1.93743 9.38184 2.18771Z"
								stroke='white' stroke-width="2" stroke-linecap="round"
								[ngStyle]="{stroke: i == qmsservice.highlightBackground ? '#005C8A' : '#FFFFFF'}" />
						</svg>
						<!-- <img
				*ngIf="item.name === 'My Tasks'"
				src="../../assets/img/my_tasks.svg"
				alt="My Tasks"
				width="20"
				height="20"
			  /> -->

						<svg *ngIf="item.name === 'My Tasks'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
							viewBox="0 0 20 20" fill="none">
							<path
								d="M7.26667 5H18M7.26667 10.4H18M7.26667 15.8H18M3 5V5.01067M3 10.4V10.4107M3 15.8V15.8107"
								stroke='white' stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
								[ngStyle]="{stroke: i == qmsservice.highlightBackground ? '#005C8A' : '#FFFFFF'}" />
						</svg>

						<!-- <img
				*ngIf="item.name === 'Quality'"
				src="../../assets/img/quality_menu.svg"
				alt="Quality"
				width="20"
				height="20"
			  /> -->

						<svg *ngIf="item.name === 'Quality'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
							viewBox="0 0 20 20" fill="none">
							<path
								d="M2.50018 10H4.16685V17.5H2.50018V10ZM15.8335 6.66667H17.5002V17.5H15.8335V6.66667ZM9.16685 1.66667H10.8335V17.5H9.16685V1.66667Z"
								[ngStyle]="{fill: i == qmsservice.highlightBackground ? '#005C8A' : '#FFFFFF'}" />
						</svg>

						<!-- <img
				*ngIf="item.name === 'Trainings'"
				src="../../assets/img/training.svg"
				alt="Trainings"
				width="20"
				height="20"
			  /> -->
						<svg *ngIf="item.name === 'Business Process'" width="24" height="25" viewBox="0 0 24 25"
							fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M11.5 16.747L10.6009 17.1847C10.7651 17.522 11.1042 17.739 11.4792 17.7468C11.8542 17.7546 12.202 17.5519 12.3801 17.2218L11.5 16.747ZM8.69913 8.7093C8.45739 8.21273 7.85887 8.00616 7.3623 8.24791C6.86574 8.48966 6.65917 9.08818 6.90091 9.58474L8.69913 8.7093ZM16.4801 9.62181C16.7423 9.13575 16.5609 8.52914 16.0748 8.26692C15.5887 8.0047 14.9821 8.18616 14.7199 8.67223L16.4801 9.62181ZM7.40002 8.54702C7.40002 9.09931 7.84774 9.54702 8.40002 9.54702C8.95231 9.54702 9.40002 9.09931 9.40002 8.54702H7.40002ZM14 8.54702C14 9.09931 14.4477 9.54702 15 9.54702C15.5523 9.54702 16 9.09931 16 8.54702H14ZM12.3991 16.3093L8.69913 8.7093L6.90091 9.58474L10.6009 17.1847L12.3991 16.3093ZM12.3801 17.2218L16.4801 9.62181L14.7199 8.67223L10.6199 16.2722L12.3801 17.2218ZM9.40002 8.54702V6.14702H7.40002V8.54702H9.40002ZM9.60002 5.94702H13.8V3.94702H9.60002V5.94702ZM14 6.14702V8.54702H16V6.14702H14ZM13.8 5.94702C13.9105 5.94702 14 6.03657 14 6.14702H16C16 4.93199 15.015 3.94702 13.8 3.94702V5.94702ZM9.40002 6.14702C9.40002 6.03656 9.48957 5.94702 9.60002 5.94702V3.94702C8.385 3.94702 7.40002 4.93199 7.40002 6.14702H9.40002ZM4.80002 9.54702H19.2V7.54702H4.80002V9.54702ZM20.6 10.947V18.147H22.6V10.947H20.6ZM19.2 19.547H4.80002V21.547H19.2V19.547ZM3.40002 18.147V10.947H1.40002V18.147H3.40002ZM4.80002 19.547C4.02683 19.547 3.40002 18.9202 3.40002 18.147H1.40002C1.40002 20.0248 2.92226 21.547 4.80002 21.547V19.547ZM20.6 18.147C20.6 18.9202 19.9732 19.547 19.2 19.547V21.547C21.0778 21.547 22.6 20.0248 22.6 18.147H20.6ZM19.2 9.54702C19.9732 9.54702 20.6 10.1738 20.6 10.947H22.6C22.6 9.06925 21.0778 7.54702 19.2 7.54702V9.54702ZM4.80002 7.54702C2.92226 7.54702 1.40002 9.06925 1.40002 10.947H3.40002C3.40002 10.1738 4.02683 9.54702 4.80002 9.54702V7.54702Z"
								[ngStyle]="{fill: i == qmsservice.highlightBackground ? '#005C8A' : '#FFFFFF'}"
								stroke="white" stroke-width="0" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
						<svg *ngIf="item.name === 'Trainings'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
							viewBox="0 0 20 20" fill="none">
							<path
								d="M2 18L2.00034 14.9997C2.00052 13.3429 3.34361 12 5.00034 12H10.5M14 12.6429L16 10.5M16 10.5L18 12.6429M16 10.5V16M14.5 2C15.7135 2.68023 16.5 3.77073 16.5 5C16.5 6.22927 15.7135 7.31977 14.5 8M12 5C12 6.65685 10.6569 8 9 8C7.34314 8 6 6.65685 6 5C6 3.34315 7.34314 2 9 2C10.6569 2 12 3.34315 12 5Z"
								[ngStyle]="{stroke: i == qmsservice.highlightBackground ? '#005C8A' : '#FFFFFF'}"
								stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
						<svg *ngIf="item.name === 'Logs'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
							viewBox="0 0 24 25" fill="none">
							<path
								d="M7.20002 12.1471L10.2 15.1471L7.20002 18.1471M3.00002 8.54709H21M4.80002 22.3471C3.47454 22.3471 2.40002 21.2726 2.40002 19.9471V5.54709C2.40002 4.22161 3.47454 3.14709 4.80002 3.14709H19.2C20.5255 3.14709 21.6 4.22161 21.6 5.54709V19.9471C21.6 21.2726 20.5255 22.3471 19.2 22.3471H4.80002Z"
								[ngStyle]="{stroke: i == qmsservice.highlightBackground ? '#005C8A' : '#FFFFFF'}"
								stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
						<!-- <img
				*ngIf="item.name === 'Documents'"
				src="../../assets/img/documents.svg"
				alt="Documents"
				width="20"
				height="20"
			  /> -->

						<svg *ngIf="item.name === 'Documents'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
							viewBox="0 0 20 20" fill="none">
							<path
								d="M2.00086 7.0139L2.00078 14.6175C2.00077 15.7221 2.8962 16.6175 4.00078 16.6175L15.9997 16.6175C17.1043 16.6176 17.9997 15.7222 17.9997 14.6176L18 6.84372C18 6.29142 17.5523 5.84369 17 5.84369H10.0697L7.76555 3.38232H3.00038C2.44794 3.38232 2.00017 3.82964 2.00034 4.38207C2.00058 5.16753 2.00086 6.2523 2.00086 7.0139Z"
								[ngStyle]="{stroke: i == qmsservice.highlightBackground ? '#005C8A' : '#FFFFFF'}"
								stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>

						<!-- <img
				*ngIf="item.name === 'Dashboards'"
				src="../../assets/img/dashboard.svg"
				alt="Dashboards"
				width="20"
				height="20"
			  /> -->
						<svg *ngIf="item.name === 'Dashboard'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
							viewBox="0 0 20 20" fill="none">
							<path
								d="M16.2222 1.99998C17.2041 1.99998 18 2.78502 18 3.75341L18 6.74659C18 7.71498 17.2041 8.50001 16.2222 8.50001H13.5556C12.5737 8.50001 11.7778 7.71498 11.7778 6.74659L11.7778 3.75341C11.7778 2.78502 12.5737 1.99998 13.5556 1.99998L16.2222 1.99998Z"
								stroke="white" stroke-width="2"
								[ngStyle]="{stroke: i == qmsservice.highlightBackground ? '#005C8A' : '#FFFFFF'}"
								stroke-linecap="round" stroke-linejoin="round" />
							<path
								d="M3.77778 1.99998C2.79594 1.99998 2 2.78502 2 3.75341L2.00001 6.74659C2.00001 7.71498 2.79595 8.50001 3.77778 8.50001H6.44445C7.42629 8.50001 8.22223 7.71498 8.22223 6.74659L8.22222 3.75341C8.22222 2.78502 7.42628 1.99998 6.44444 1.99998L3.77778 1.99998Z"
								[ngStyle]="{stroke: i == qmsservice.highlightBackground ? '#005C8A' : '#FFFFFF'}"
								stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
							<path
								d="M16.2222 11.5C17.2041 11.5 18 12.285 18 13.2534V16.2466C18 17.215 17.2041 18 16.2222 18H13.5556C12.5737 18 11.7778 17.215 11.7778 16.2466L11.7778 13.2534C11.7778 12.285 12.5737 11.5 13.5556 11.5H16.2222Z"
								[ngStyle]="{stroke: i == qmsservice.highlightBackground ? '#005C8A' : '#FFFFFF'}"
								stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
							<path
								d="M3.77778 11.5C2.79594 11.5 2.00001 12.285 2.00001 13.2534L2.00001 16.2466C2.00001 17.215 2.79595 18 3.77779 18H6.44445C7.42629 18 8.22223 17.215 8.22223 16.2466L8.22223 13.2534C8.22223 12.285 7.42629 11.5 6.44445 11.5H3.77778Z"
								[ngStyle]="{stroke: i == qmsservice.highlightBackground ? '#005C8A' : '#FFFFFF'}"
								stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
						<svg *ngIf="item.name === 'Organization'" xmlns="http://www.w3.org/2000/svg" width="24"
							height="25" viewBox="0 0 24 25" fill="none">
							<path
								d="M4.00002 15.7471V13.0784M9.33336 15.7471V13.0784M14.6667 15.7471V13.0784M20 15.7471V13.0784M2.40002 19.1471H21.6V22.3471H2.40002V19.1471ZM2.40002 9.54709V7.41376L11.6055 3.14709L21.6 7.41376V9.54709H2.40002Z"
								stroke="#005C8A"
								[ngStyle]="{stroke: i == qmsservice.highlightBackground ? '#005C8A' : '#FFFFFF'}"
								stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
						<!-- <svg  xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 25" fill="none"
			  >
			  <path d="M7.20002 12.1471L10.2 15.1471L7.20002 18.1471M3.00002 8.54709H21M4.80002 22.3471C3.47454 22.3471 2.40002 21.2726 2.40002 19.9471V5.54709C2.40002 4.22161 3.47454 3.14709 4.80002 3.14709H19.2C20.5255 3.14709 21.6 4.22161 21.6 5.54709V19.9471C21.6 21.2726 20.5255 22.3471 19.2 22.3471H4.80002Z" [ngStyle]="{stroke: i == qmsservice.highlightBackground ? '#005C8A' : '#FFFFFF'}" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
		   </svg> -->
						<!-- <img
				*ngIf="item.name === 'Admin'"
				src="../../assets/img/admin.svg"
				alt="Admin"
				width="20"
				height="20"
			  /> -->
						<svg *ngIf="item.name === 'Admin'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
							viewBox="0 0 20 20" fill="none">
							<path
								d="M10 14V16M7 17H13M4 14H16C17.1046 14 18 13.1046 18 12V5C18 3.89543 17.1046 3 16 3H4C2.89543 3 2 3.89543 2 5V12C2 13.1046 2.89543 14 4 14Z"
								[ngStyle]="{stroke: i == qmsservice.highlightBackground ? '#005C8A' : '#FFFFFF'}"
								stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
						<!-- <img
				*ngIf="item.name === 'Settings'"
				src="../../assets/img/setup.svg"
				alt="Settings"
				width="20"
				height="20"
			  /> -->
						<svg *ngIf="item.name === 'Settings'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
							viewBox="0 0 20 20" fill="none">
							<path
								d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z"
								[ngStyle]="{fill: i == qmsservice.highlightBackground ? '#005C8A' : '#FFFFFF'}" />
						</svg>
						<!-- <img
				*ngIf="item.name === 'Sign Out'"
				src="../../assets/img/sign_out.svg"
				alt="Sign Out"
				width="20"
				height="20"
			  /> -->
						<svg *ngIf="item.name === 'Logout'" xmlns="http://www.w3.org/2000/svg" width="20" height="20"
							viewBox="0 0 20 20" fill="none">
							<path
								d="M12.2059 6.5V4.75C12.2059 4.28587 12.02 3.84075 11.689 3.51256C11.3581 3.18437 10.9092 3 10.4412 3H4.26471C3.79668 3 3.34782 3.18437 3.01687 3.51256C2.68592 3.84075 2.5 4.28587 2.5 4.75V15.25C2.5 15.7141 2.68592 16.1592 3.01687 16.4874C3.34782 16.8156 3.79668 17 4.26471 17H10.4412C10.9092 17 11.3581 16.8156 11.689 16.4874C12.02 16.1592 12.2059 15.7141 12.2059 15.25V13.5M6.91176 10H17.5M17.5 10L14.8529 7.375M17.5 10L14.8529 12.625"
								[ngStyle]="{stroke: i == qmsservice.highlightBackground ? '#005C8A' : '#FFFFFF'}"
								stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
						<!-- <i
				[className]="
				  item.name == 'My Tasks'
					? 'fas fa-tasks'
					: item.name == 'Quality'
					? 'fas fa-certificate'
					: item.name == 'Trainings'
					? 'fas fa-chalkboard-teacher'
					: item.name == 'Dashboards'
					? 'fas fa-chart-bar'
					: item.name == 'Documents'
					? 'fas fa-folder-open'
					: item.name == 'Admin'
					? 'fas fa-users-cog'
					: item.name == 'Settings'
					? 'fas fa-cog'
					: item.name == 'Topics'
					? 'fa-solid fa-file-lines'
					: item.name == 'Releases'
					? 'fa-solid fa-bars-staggered'
					: item.name == 'Home'
					? 'fa-solid fa-house'
					: ''
				"
				aria-hidden="true"
			  >
		  </i> -->
					</div>
					<div class="item-name">&nbsp;{{ item.name }}</div>
				</div>
			</div>
		</div>
	</div>


</div>
<div class="basic-container" *ngIf="this.message.showLeftMenu == 'Activity'">
	<div *ngFor="let item of message.activityLeftmenuList">
		<div [hidden]="
		  (message.showActionSection == false && item.name == 'Actions') ||
		  (message.showAddtionalDetailSection == false &&
			item.name == 'Additional Information') ||
		  (message.showEffectiveSection == false &&
			item.name == 'Effectiveness Check') ||
		  (message.showDocumentSection == false && item.name == 'Documents') ||
		  (message.showReviewApproveSection == false &&
			item.name == 'Reviewers/Approvers') ||
		  (message.showExtensionSection == false && item.name == 'Extensions') ||
		  (message.showNotificationSection == false &&
			item.name == 'Notifications/Reminders') ||
		  (message.showDependancySection == false && item.name == 'Dependency')
		">
			<div class="row" mat-button class="activity-item-block" (click)="ActivityPages(item.name)"
				[title]="item.name">
				<div>
					<div class="item-name-icon">
						<i [className]="
				  item.name == 'Change Request'
					? 'fa-solid fa-file-pen'
					: item.name == 'Additional Information'
					? 'far fa-info-circle'
					: item.name == 'Documents'
					? 'fa-regular fa-file'
					: item.name == 'Reviewers/Approvers'
					? 'fa-solid fa-file-circle-check'
					: item.name == 'Notifications/Reminders'
					? 'far fa-bell'
					: item.name == 'Effectiveness Check'
					? 'far fa-check-square'
					: item.name == 'Extensions'
					? 'fa-regular fa-file-code'
					: item.name == 'Actions'
					? 'fa-solid fa-file-invoice'
					: item.name == 'Dependency'
					? 'fa-solid fa-layer-group'
					: 'fas fa-chart-bar'
				" aria-hidden="true"></i>
					</div>
					<!-- <div  class="item-name">&nbsp;{{item.name}}</div> -->
				</div>
			</div>
		</div>
	</div>
</div>

<!-- <div class="position-fixed bottom-0">
	<div>
	  <img src="../../assets/img/qms_img/clinevo_bg.png" width="100px" height="125px" alt="">
	</div>
	<div class="clinevo_logo_block">
	  <img src="../../assets/img/qms_img/clinevo_logo.svg" width="100px" height="89px" alt="">
	</div>
  
  </div> -->